import React, { useEffect, useState } from 'react'
import { DarkBold, lastOne, LighterBig, smallLighterText, smallText } from '../../Assets/CSS/Text'
import { Icon } from "@iconify/react";
import axios from 'axios';
import toast from 'react-hot-toast';

const ClearanceTask = () => {
    // const [taskName, setTaskName] = useState("");
    // const [taskDesc, setTaskDesc] = useState("");
    // const [department, setDepartment] = useState("IT");
    const [taskForm, setTaskForm] = useState({
        taskName: "",
        taskDescription: "",
        department: "IT"
    });


    const handleAddTask = async () => {
        if (!taskForm.taskName.trim()) return;

        try {
            const token = localStorage.getItem("token");

            const res = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/v1/offboarding/configuration/tasks`,
                taskForm,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            const createdTask = res.data;

            toast.success("Added New Task Template successfully");

            setTasks({
                ...tasks,
                [taskForm.department]: [
                    ...(tasks[taskForm.department] || []),
                    {
                        id: createdTask.templateId,
                        name: createdTask.taskName,
                        desc: createdTask.taskDescription,
                    },
                ],
            });

            setTaskForm({
                taskName: "",
                taskDescription: "",
                department: taskForm.department,
            });

        } catch (error) {
            toast.error("Not Added New Task Template");
            console.error("Failed to create task", error);
        }
    };



    const [tasks, setTasks] = useState({
        IT: [
            { name: "Collect laptop", desc: "Retrieve company laptop from employee" },
            { name: "Collect access card", desc: "Retrieve building access card" },
        ],
        Finance: [
            { name: "Clear pending expenses", desc: "Process and clear all pending expense claims" },
            { name: "Settlement of loans", desc: "Calculate and settle any outstanding loans" },
        ],
    });

    // Delete task
    // const handleDelete = (dept, index) => {
    //     const updated = { ...tasks };
    //     updated[dept].splice(index, 1);
    //     setTasks(updated);
    // };

    const handleDelete = async (dept, index) => {
        const token = localStorage.getItem("token");
        const taskId = tasks[dept][index].id;

        try {
            await axios.delete(
                `${process.env.REACT_APP_BACKEND_URL}/api/v1/offboarding/configuration/tasks/${taskId}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            // 🔹 Update UI without reload
            setTasks({
                ...tasks,
                [dept]: tasks[dept].filter((_, i) => i !== index),
            });

            toast.success("Task deleted successfully");

        } catch (error) {
            console.error("DELETE TASK ERROR:", error);
            toast.error("Failed to delete task");
        }
    };


    const token = localStorage.getItem("token");

    useEffect(() => {
        fetchTasks();
    }, []);

    const fetchTasks = async () => {
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/api/v1/offboarding/configuration/tasks`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            // 🔹 Transform API response to UI format
            const groupedTasks = {};

            res.data.forEach((item) => {
                const dept = item.department;

                if (!groupedTasks[dept]) {
                    groupedTasks[dept] = [];
                }

                groupedTasks[dept].push({
                    id: item.templateId,      // ✅ MUST add this
                    name: item.taskName,
                    desc: item.taskDescription,
                });

            });

            setTasks(groupedTasks);

        } catch (error) {
            console.error("Error fetching tasks:", error);
        }
    };

    return (
        <div className="container px-2">

            <span style={smallLighterText}>Define tasks that will be automatically
                assigned to departments when an offboarding is initiated.</span>

            {/* ---------- Add New Task Template ---------- */}
            <div className="bg-light p-4 rounded shadow-sm mb-4 mt-3" >
                <h6 style={lastOne}>Add New Task Template</h6>

                <div className="row mt-3">
                    <div className="col-md-5 mb-3">

                        <label style={smallText} className="form-label fw-semibold">Task Name <span className='text-danger'>*</span></label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="eg: Collect Laptop"
                            value={taskForm.taskName}
                            onChange={(e) =>
                                setTaskForm({ ...taskForm, taskName: e.target.value })
                            }
                        />
                    </div>

                    <div className="col-md-5 mb-3">
                        <label className="form-label fw-semibold">Department</label>
                        <select
                            className="form-select"
                            value={taskForm.department}
                            onChange={(e) =>
                                setTaskForm({ ...taskForm, department: e.target.value })
                            }
                        >
                            <option value="IT">IT</option>
                            <option value="Finance">Finance</option>
                            <option value="HR">HR</option>
                        </select>
                    </div>
                </div>
                <div className='col-md-10'>
                    <label className="form-label fw-semibold">Task Description</label>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Add description"

                        value={taskForm.taskDescription}
                        onChange={(e) =>
                            setTaskForm({ ...taskForm, taskDescription: e.target.value })
                        }
                    />
                </div>


                <button
                    className="submit-btn mt-3 px-4 py-2 d-flex align-items-center gap-2"
                    onClick={handleAddTask}
                >
                    <span className="fs-5">+</span> Add Task
                </button>
            </div>

            {/* ---------- List by Departments ---------- */}
            <div className='col-md-10'>


                {/* {Object.keys(tasks).map((dept) => ( */}
                {Object.keys(tasks).map((dept) => (
                    <div key={dept} className="mb-4">

                        <h6 style={lastOne} className=" mb-3">
                            {dept} Department Tasks ({tasks[dept].length})
                        </h6>

                        {tasks[dept].map((task, index) => (
                            <div
                                key={index}
                                className=" p-2 mb-2 d-flex justify-content-between align-items-start"
                                style={{
                                    border: '1px solid #BEBEBE',
                                    borderRadius: '10px'
                                }}
                            >
                                <div>
                                    <h6 style={{ ...DarkBold, margin: '0px' }}>{task.name}</h6>
                                    <small style={smallLighterText}>{task.desc}</small>
                                </div>


                                <button
                                    className="btn"
                                    onClick={() => handleDelete(dept, index)}
                                >
                                    <Icon icon="material-symbols:delete-outline" style={{ color: '#909090' }} />
                                </button>

                            </div>
                        ))}
                    </div>
                ))}
            </div>

        </div>
    )
}

export default ClearanceTask